export const avatars = [
  require("./img/001.jpg"),
  require("./img/002.jpg"),
  require("./img/003.jpg"),
  require("./img/004.jpg"),
  require("./img/005.jpg"),
  require("./img/006.jpg"),
  require("./img/007.jpg"),
  require("./img/008.jpg"),
  require("./img/009.jpg"),
  require("./img/010.jpg"),
  require("./img/011.jpg"),
  require("./img/012.jpg"),
  require("./img/013.jpg"),
  require("./img/014.jpg"),
  require("./img/015.jpg"),
  require("./img/016.jpg"),
  require("./img/017.jpg"),
  require("./img/018.jpg"),
  require("./img/019.jpg"),
  require("./img/020.jpg"),
];
